module.exports = __webpack_public_path__ + "img/pr-6.5263c507.png";